/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolIcecreamIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-icecream"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.2 9.7Q2.2 8.2 3.05 7.05Q3.9 5.9 4.95 5.45Q5.53 3.17 7.44 1.54Q9.35 -0.1 12 -0.1Q14.65 -0.1 16.56 1.54Q18.48 3.17 19.05 5.45Q20.1 5.9 20.95 7.05Q21.8 8.2 21.8 9.7Q21.8 11.82 20.38 13.09Q18.95 14.35 17.1 14.5L13.18 22.05Q12.97 22.4 12.66 22.57Q12.35 22.75 12 22.75Q11.65 22.75 11.34 22.57Q11.03 22.4 10.82 22.05L6.9 14.5Q4.88 14.3 3.54 13.06Q2.2 11.82 2.2 9.7ZM12 18.55L14.35 14.05L14.35 14.05Q13.82 14.22 13.29 14.31Q12.75 14.4 12 14.4Q11.25 14.4 10.72 14.31Q10.2 14.22 9.65 14.05L9.65 14.05Z" fill={color} />
    </svg>
  );
}
